import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
import {ICamsPhoto} from "@/modules/Car/interfaces/cams-photo.interface";
import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
import {IApp} from "@/interfaces/app.interface";
import store from "@/store/store";
import {bus} from "@/plugins/bus";
import {IAppState} from "@/interfaces/app-state.interface";
import _ from "lodash";

export interface IOpenMediaPopupPayload {
  item: IMovementsReport.IDataItem;
  index: number;
  tableList: IMovementsReport.IDataItem[];
  fromCarPopup?: boolean;
}

export async function openMediaPopup({item, index, tableList, fromCarPopup = false}: IOpenMediaPopupPayload) {
  if (!item.hasPhoto) return;

  let dateInName = fromCarPopup ? 'dateBeg' : 'dateIn';
  let dateOutName = fromCarPopup ? 'dateEnd' : 'dateOut';

  const resourcePayload: ICamsPhoto.IPayloadMoves = {
    movId: item.movId,
    carNumber: item.carNumber,
  };
  const { response } = await ICamsPhoto.GetCamsPhoto(resourcePayload);
  const mediaPayload: IAppMediaPopup.IPayload = {
    files: response && response.length ? response : [],
    parentList: {
      name: fromCarPopup ? IAppMediaPopup.MediaPopupSourceCall.CarPopupMovements : IAppMediaPopup.MediaPopupSourceCall.ReportMovements,
      currentIndex: index,
      total: tableList.length - 1,
    },
    mediaInfo: {
      carNumber: item.carNumber,
      props: [
        { cells: [
            { label: 'Дата въезда: ', value: bus.$options.filters.moment(item[dateInName], IApp.DateFormats.PrintedDateTimeFull) },
            { label: 'Дата выезда: ', value: bus.$options.filters.moment(item[dateOutName], IApp.DateFormats.PrintedDateTimeFull) },
          ]
        },
        { cells: fromCarPopup
            ? [
              { label: 'Парковка: ', value: (item as any).parkName },
            ]
            : [
              { label: 'ФИО: ', value: item.persName },
              { label: 'Корпорация: ', value: item.corpName },
            ]
        },
      ],
    }
  };

  let payload: any = { ...mediaPayload, };

  if (fromCarPopup) {
    store.commit('car/setProperty', { name: 'displayContent', value: false });
    payload = {
      ...payload,
      closeAction: () => {
        store.commit('car/setProperty', { name: 'displayContent', value: true });
      }
    };
  }

  if (!_.isEqual((store.state as IAppState).dialog.activePopup, { blockName: 'allPages', dialogName: 'appMediaPopup' })) {
    await store.dispatch('dialog/openDialog', {
      blockName: 'allPages',
      dialogName: 'appMediaPopup',
      payload,
    });
  }
  else {
    store.commit('dialog/updateActivePopupPayload', payload);
    await store.dispatch('dialog/reloadPopup');
  }
}